import { type Cookies, error } from '@sveltejs/kit';

export const StripeCookies = {
  CheckoutSessionId: 'stripe.checkout-session-id',
  SetupIntentId: 'stripe.setup-intent-id',
};

export const Auth0Cookies = {
  AccessToken: 'auth0.access_token',
  IdToken: 'auth0.id_token',
};

export const ReturnTo = 'returnTo';
export const SelectedPlan = 'selectedPlan';

export async function delCookie(cookies, key) {
  if (typeof cookies.delete === 'function') {
    cookies.delete(key, {
      path: '/',
    });
  } else {
    cookies.remove(key, {
      path: '/',
    });
  }
}

export async function setAccessToken(cookies: Cookies, data) {
  cookies.set(Auth0Cookies.AccessToken, data.access_token || data.accessToken, {
    path: '/',
  });

  if (data.id_token || data.idToken) {
    cookies.set(Auth0Cookies.IdToken, data.id_token || data.idToken, {
      path: '/',
    });
  }

  // Clear session cookies
  await clearStripeCookies(cookies);
}

export async function getAccessToken(cookies: Cookies) {
  const token = cookies.get(Auth0Cookies.AccessToken);

  if (!token) {
    throw error(401, { message: 'Unauthorized' });
  }

  return token;
}

export async function getIdToken(cookies: Cookies) {
  const idToken = cookies.get(Auth0Cookies.IdToken);

  if (!idToken) {
    throw error(401, { message: 'Unauthorized' });
  }

  return idToken;
}

export async function clearAccessToken(cookies: Cookies) {
  cookies.delete(Auth0Cookies.AccessToken, {
    path: '/',
  });

  cookies.delete(Auth0Cookies.IdToken, {
    path: '/',
  });

  // Clear session cookies
  await clearStripeCookies(cookies);
}

export async function clearStripeCookies(cookies) {
  await delCookie(cookies, StripeCookies.SetupIntentId);
  await delCookie(cookies, StripeCookies.CheckoutSessionId);
}

export async function setSetupIntentId(cookies: Cookies, setupIntentId: string) {
  cookies.set(StripeCookies.SetupIntentId, setupIntentId, {
    path: '/',
  });
}

export async function getSetupIntentId(cookies: Cookies) {
  return cookies.get(StripeCookies.SetupIntentId);
}

export async function setCheckoutSessionId(cookies: Cookies, sessionId: string) {
  cookies.set(StripeCookies.CheckoutSessionId, sessionId, {
    path: '/',
  });
}

export async function getCheckoutSessionId(cookies: Cookies) {
  return cookies.get(StripeCookies.CheckoutSessionId);
}

export async function setReturnTo(cookies: Cookies, returnTo: string) {
  cookies.set(ReturnTo, returnTo, {
    path: '/',
  });
}

export async function getAndResetReturnTo(cookies: Cookies) {
  const returnTo = cookies.get(ReturnTo);
  await delCookie(cookies, ReturnTo);

  return returnTo;
}

export async function setSelectedPlan(cookies: Cookies, plan: string) {
  cookies.set(SelectedPlan, plan, {
    path: '/',
  });
}

export async function getSelectedPlan(cookies: Cookies) {
  return cookies.get(SelectedPlan);
}

export async function clearSelectedPlan(cookies) {
  await delCookie(cookies, SelectedPlan);
}
